export default __webpack_public_path__ + "static/media/ed-tech.6944ef1b.jpg";